const atmosphere = require('atmosphere.js');

/*@ngInject*/
const PersistentConnection = function ($rootScope, $state, $q, $timeout, $window, localization, alertHandler, umsLog, coreConstant, submissionConstant, formViewerConstant, coreMediator, logUtil, modalUtil, preferenceModel) {

    let isConnected = false,
        isConnecting = false,
        isReconnect = false,
        defer = null,
        logLevel = 'info',
        activeTransactions = {},
        connection,
        connectionTimeout;

    function alert(message) {
        message = convertPersistentConnectionMessageToAlert(message);
        if (message.email) {
            $rootScope.$broadcast(coreConstant.event.SHOW_EMAIL_MODAL_NOTIFICATION, message);
        }
        else if (message.emailNotificationDraftId) {
            /*
             * UMS-26310
             * Add the chat-message, email-message and notification ids to the SHOW_EMAIL_EDITOR broadcast.
             * This is step 5 of 6.
             * The next step is in the function handling SHOW_EMAIL_EDITOR in collaborationController.js.
             * The previous step is in the BaseEmailNotifier.sendEmailMessage method.
             */
            $rootScope.$broadcast(coreConstant.event.SHOW_EMAIL_EDITOR,
                                  message.emailNotificationDraftId,
                                  message.variables.submissionId,
                                  message.variables.chatMessageId,
                                  message.variables.emailMessageId,
                                  message.variables.notificationId,
                                  message.deleteNewEmailOnCancel);
        }
        else if (message.progressBar) {
            if (message.progressBar !== 'hide') {
                $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR, message.progressBar, message.variables.submissionId);
            } else {
                $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR, message.variables.submissionId);
            }
        }
        else if (message.refreshSubmission) {
            $rootScope.$broadcast(submissionConstant.event.RELOAD_SUBMISSION, message.variables.submissionId);
        }
        else {
            alertHandler.showAlert(message);
        }
    }

    function convertPersistentConnectionMessageToAlert(persistentConnectionMessage) {
        if (persistentConnectionMessage) {
            let returnObject = {},
                xmlDoc = $.parseXML(persistentConnectionMessage.payload.body),
                fields = $(xmlDoc).find('fields'),
                variables = {},
                namedParameters = ['message', 'title', 'email', 'progressBar', 'refreshSubmission', 'notification', 'notificationValue', 'customButtonType', 'emailNotificationDraftId', 'deleteNewEmailOnCancel', 'customButtonNames', 'customButtons'],
                customButtonNamesString;

            _.each(fields.children(), function (value) {
                if (namedParameters.indexOf(value.tagName) === -1) {
                    variables[value.tagName] = $(value).text();
                }
                else if (value.tagName === 'customButtonNames') {
                    customButtonNamesString = $(value).text();
                    if (customButtonNamesString) {
                        variables[value.tagName] = customButtonNamesString.split('::');
                    }
                } else if (value.tagName === 'customButtons') {
                    let customButtons = [];
                    _.each(value.childNodes, function (child) {
                        let customButton = {};
                        _.each(child.childNodes, function (item) {
                            customButton[item.tagName] = $(item).text();
                        });
                        customButtons.push(customButton);
                    });
                    returnObject[value.tagName] = customButtons;
                }
                else {
                    returnObject[value.tagName] = $(value).text();
                }
            });
            returnObject.channel = persistentConnectionMessage.objectUri;
            returnObject.variables = variables;
            return returnObject;
        }
    }

    function checkForActiveTransaction(correlationId, totalMessageCount) {
        if (_.isUndefined(activeTransactions[correlationId])) {
            // This is a new transaction.
            if (logLevel === 'debug') {
                umsLog.debug('Start transaction -- ' + correlationId);
            }
            activeTransactions[correlationId] = {
                messagesRemaining: totalMessageCount,
                updatedSubmissionId: 0
            };
        }
    }

    function checkAndHandleEndOfTransaction(messagesRemaining, correlationId) {
        let isEndOfTransaction = messagesRemaining === 0,
            activeTransaction,
            updatedSubmission,
            updatedSubmissionId,
            updatedQuoteSummary,
            updatedPolicyChanges,
            updatedProposalSummary,
            navigationItem,
            navigationItemSubmissionUri,
            navigationItemActorPrincipalName,
            isDelete,
            isQuoteDeleted,
            isProposalDeleted,
            createRowMessages,
            updateRowMessages,
            deleteRowMessages,
            createdNotification,
            updatedNotifications;

        if (isEndOfTransaction) {
            activeTransaction = activeTransactions[correlationId];
            updatedSubmission = activeTransaction.updatedSubmission;
            updatedSubmissionId = activeTransaction.updatedSubmissionId;
            updatedQuoteSummary = activeTransaction.updatedQuoteSummary;
            updatedPolicyChanges = activeTransaction.updatedPolicyChanges;
            updatedProposalSummary = activeTransaction.updatedProposalSummary;
            navigationItem = activeTransaction.navigationItem;
            navigationItemSubmissionUri = activeTransaction.navigationItemSubmissionUri;
            navigationItemActorPrincipalName = activeTransaction.navigationItemActorPrincipalName;
            isDelete = activeTransaction.isDelete;
            isQuoteDeleted = activeTransaction.isQuoteDeleted;
            isProposalDeleted = activeTransaction.isProposalDeleted;
            createRowMessages = activeTransaction.createRowMessages;
            updateRowMessages = activeTransaction.updateRowMessages;
            deleteRowMessages = activeTransaction.deleteRowMessages;
            createdNotification = activeTransaction.createdNotification;
            updatedNotifications = activeTransaction.updatedNotifications;

            if (updatedSubmissionId > 0) {
                if (!isDelete) {
                    if (updatedSubmission) {
                        updateSubmission(updatedSubmission);
                    }
                } else {
                    // Either you or someone else deleted this submission, so close the submission (if open) and deregister.
                    $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, updatedSubmissionId);
                }
            }

            if (updatedQuoteSummary) {
                if (!isQuoteDeleted) {
                    $rootScope.$broadcast(coreConstant.event.REFRESH_QUOTE, updatedQuoteSummary);
                } else {
                    $rootScope.$broadcast(coreConstant.event.QUOTE_DELETED, updatedQuoteSummary);
                }
            }

            if (updatedPolicyChanges) {
                _.each(updatedPolicyChanges, function (policyChange) {
                    $rootScope.$broadcast(coreConstant.event.REFRESH_POLICY_CHANGE, policyChange);
                });
            }

            if (updatedProposalSummary) {
                if (!isProposalDeleted) {
                    $rootScope.$broadcast(coreConstant.event.REFRESH_PROPOSAL, updatedProposalSummary, updatedSubmissionId);
                } else {
                    $rootScope.$broadcast(coreConstant.event.PROPOSAL_DELETED, updatedProposalSummary, updatedSubmissionId);
                }
            }

            if (navigationItem) {
                $rootScope.$broadcast(
                    coreConstant.event.UPDATE_NAVIGATION_ITEM_MESSAGE,
                    navigationItemSubmissionUri,
                    navigationItem,
                    navigationItemActorPrincipalName);
            }

            if (deleteRowMessages && _.size(deleteRowMessages) !== 0) {
                _.each(deleteRowMessages, function (deleteRowMessage) {
                    $rootScope.$broadcast(formViewerConstant.event.DELETE_ROW, deleteRowMessage);
                });
            }

            if (createRowMessages && _.size(createRowMessages) !== 0) {
                _.each(createRowMessages, function (createRowMessage) {
                    $rootScope.$broadcast(formViewerConstant.event.CREATE_ROW, createRowMessage);
                });
            }

            if (updateRowMessages && _.size(updateRowMessages) !== 0) {
                _.each(updateRowMessages, function (updateRowMessage) {
                    $rootScope.$broadcast(formViewerConstant.event.UPDATE_ROW, updateRowMessage);
                });
            }

            if (createdNotification) {
                $rootScope.$broadcast(coreConstant.event.CREATE_NOTIFICATION, createdNotification);
            }

            if (updatedNotifications) {
                $rootScope.$broadcast(coreConstant.event.UPDATE_NOTIFICATION, updatedNotifications);
            }

            if (logLevel === 'debug') {
                umsLog.debug('End transaction -- ' + correlationId);
            }

            delete activeTransactions[correlationId];
        }
    }

    function updateSubmission(submission) {
        // Send an event to anyone who is interested that we've received an update for this submission.
        $rootScope.$broadcast(coreConstant.event.UPDATE_SUBMISSION, submission);
    }

    this.connect = function () {
        // If we are already connected, immediately return a resolved promise.
        if (isConnected) {
            return $q.when();
        }

        if (_.isNull(defer)) {
            defer = $q.defer();
        }

        if (isConnecting) {
            // In the case where we have multiple calls to this method at the same time AND
            // it hasn't connected yet, we want to return the same promise to all the callers so that
            // we can resolve that single promise when the connection opens.
            return defer.promise;
        } else {
            if (logLevel === 'debug') {
                umsLog.debug('persistentConnection.connect()');
            }
            let maxReconnectOnClose = preferenceModel.get('system.persistentConnectionMaxReconnectOnClose') || 2,
                reconnectInterval = preferenceModel.get('system.persistentConnectionReconnectInterval') || 500,
                request = {
                    method: 'POST',
                    maxReconnectOnClose: maxReconnectOnClose,
                    reconnectInterval: reconnectInterval,
                    url: '/rest/v2/PersistentConnection',
                    transport: 'streaming',
                    timeout: -1,
                    logLevel: logLevel,
                    trackMessageLength: true,
                    readResponsesHeaders: true,
                    closeAsync: true,
                    data: 'Authorization=' + coreMediator.getLoginTokenAuthorizationHeader()
                };

            if (coreMediator.getClientId()) {
                request.uuid = coreMediator.getClientId();
            }

            request.onOpen = this.onOpen;
            request.onMessage = this.onMessage;
            request.onClose = this.onClose;
            request.onReconnect = this.onReconnect;
            request.onReopen = this.onReopen;
            request.onError = this.onError;

            // Initiate the suspended POST using the options configured above.
            isConnecting = true;
            connection = atmosphere.subscribe(request);
            connectionTimeout = $timeout(function () {
                modalUtil.showPersistentConnectionFailed();
                logUtil.logWarning('Persistent connection failed to connect.');
            }, 5000);
        }
        return defer.promise;
    };

    this.onOpen = function () {
        let clientId = this.uuid;

        if (logLevel === 'debug') {
            umsLog.debug('persistentConnection.onOpen()');
        }
        if(!_.isNil(connectionTimeout)){
            $timeout.cancel(connectionTimeout);
        }
        coreMediator.setClientId(clientId);

        activeTransactions = {};
        alertHandler.start(clientId);
        isConnecting = false;
        isConnected = true;
        if (defer) {
            defer.resolve();
        }
        defer = null;

        logUtil.logInfo('Client Connected');
    };

    this.onClose = function () {
        if (logLevel === 'debug') {
            umsLog.debug('persistentConnection.onClose()');
        }

        if(!_.isNil(connectionTimeout)){
            $timeout.cancel(connectionTimeout);
        }

        isConnected = false;

        $timeout(function () {
            if (!_.isNil(connection) && !isReconnect) {
                modalUtil.showServerDisconnectedModal();
            } else {
                isReconnect = false;
            }
        }, 500);
    };

    this.disconnectAndAlert = disconnectAndAlert;

    function disconnectAndAlert() {
        disconnect().finally(function () {
            modalUtil.showServerDisconnectedModal();
        });
    }

    this.disconnect = disconnect;

    function disconnect() {
        if(!_.isNil(connectionTimeout)){
            $timeout.cancel(connectionTimeout);
        }
        if (isConnected) {
            disconnectAtmosphere();
            coreMediator.removeClientId();
            return $q.when();
        } else if (isConnecting) {
            return defer.promise.then(disconnect);
        } else {
            return $q.reject();
        }
    }

    function disconnectAtmosphere() {
        activeTransactions = {};
        isConnecting = false;
        isConnected = false;
        atmosphere.unsubscribe();
        connection = null;
    }

    this.onReconnect = function (request) {
        // During a reconnect, we need to update the request URL because our Authorization token
        // may have changed since we last connected, and we don't want to send an expired token.
        request.data = 'Authorization=' + coreMediator.getLoginTokenAuthorizationHeader();

        if (logLevel === 'debug') {
            umsLog.debug('persistentConnection.onReconnect()');
        }

        if(!_.isNil(connectionTimeout)){
            $timeout.cancel(connectionTimeout);
        }

        isConnected = true;
        isReconnect = true;
        coreMediator.setClientId(this.uuid);
    };

    // Debounce the onReopen method because sometimes atmosphere decides to invoke onReopen
    // *a lot* when the connection is re-established.
    this.onReopen = _.debounce(function () {
        if (logLevel === 'debug') {
            umsLog.debug('persistentConnection.onReopen()');
        }

        if(!_.isNil(connectionTimeout)){
            $timeout.cancel(connectionTimeout);
        }

        coreMediator.setClientId(this.uuid);

        logUtil.logInfo('Client Reconnect: client-side disconnect');
    }, 1000, {leading: true, trailing: false});

    this.onError = function () {
        if (logLevel === 'debug') {
            umsLog.debug('persistentConnection.onError()');
        }

        disconnectAndAlert();
    };

    this.onMessage = function (response) {
        /**
         * @param persistentConnectionMessage.totalMessageCount
         * @param persistentConnectionMessage.correlationId
         */
        let persistentConnectionMessage = JSON.parse(response.responseBody),
            totalMessageCount = persistentConnectionMessage.totalMessageCount,
            correlationId = persistentConnectionMessage.correlationId,
            actorPrincipalName = persistentConnectionMessage.actorPrincipalName,
            objectUri = persistentConnectionMessage.objectUri ? persistentConnectionMessage.objectUri.toLocaleLowerCase() : '',
            messagePayload = persistentConnectionMessage.payload,
            messagesRemaining,
            isDynamicDatasetMessage = objectUri.indexOf('dynamicdataset') !== -1,
            isFieldMessage = objectUri.indexOf('field') !== -1,
            isFormMessage = objectUri.indexOf('form') !== -1,
            isRowMessage = objectUri.indexOf('formrow') !== -1,
            isNavigationItemMessage = objectUri.indexOf('navigationitem') !== -1,
            isSubmissionUpdate = objectUri.indexOf('\/submission\/') > -1,
            isQuoteUpdate = objectUri.indexOf('\/quote\/') > -1,
            isPolicyChangeUpdate = objectUri.indexOf('\/policy') === 0 || objectUri.indexOf('\/endorsement') === 0 || objectUri.indexOf('\/policyrewrite') === 0,
            isCollaborationItemMessage = objectUri.indexOf('note') !== -1 || objectUri.indexOf('attachment') !== -1 || objectUri.indexOf('email') !== -1 || objectUri.indexOf('task') !== -1 || objectUri.indexOf('collabmessage') !== -1,
            isActionsMessage = objectUri.indexOf('\/actions') !== -1,
            isProposalUpdate = objectUri.indexOf('\/proposal\/') > -1,
            isNotificationUpdate = objectUri.indexOf('\/notification\/') > -1,
            isChatMessage = objectUri.indexOf('\/message\/') > -1,
            isUserMessage = objectUri.indexOf('\/user\/') > -1,
            isOrganizationMessage = objectUri.indexOf('\/organization\/') > -1,
            isInvalidSession = response.status === 454,
            isPingMessage = persistentConnectionMessage.type === 'ping',
            isCreateType,
            isDeleteType,
            isUpdateType,
            isDelete,
            isRenameType;

        if (logLevel === 'debug') {
            umsLog.debug('persistentConnection.onMessage()');
            umsLog.debug(JSON.stringify(persistentConnectionMessage, null, 2));
        }

        if (isInvalidSession) {
            disconnect();
            return;
        }

        function handleSubmissionUpdate() {
            // Postpone submission update processing until the end of the transaction.
            let submission = messagePayload;

            isDelete = persistentConnectionMessage.type === 'Delete';

            activeTransactions[correlationId].updatedSubmission = submission;
            activeTransactions[correlationId].updatedSubmissionId = submission.id;
            activeTransactions[correlationId].isDelete = isDelete;
        }

        function handleQuoteUpdate() {
            let quoteSummary = messagePayload;

            isDelete = persistentConnectionMessage.type === 'Delete';

            activeTransactions[correlationId].updatedQuoteSummary = quoteSummary;
            activeTransactions[correlationId].updatedSubmissionId = quoteSummary.submissionId;
            activeTransactions[correlationId].isQuoteDeleted = isDelete;
        }

        function handlePolicyChangeUpdate() {
            let policyChange = messagePayload;

            if (_.isNil(activeTransactions[correlationId].updatedPolicyChanges)) {
                activeTransactions[correlationId].updatedPolicyChanges = [];
            }

            activeTransactions[correlationId].updatedPolicyChanges.push(policyChange);
            activeTransactions[correlationId].updatedSubmissionId = policyChange.submissionId;
        }

        function handleProposalUpdate() {
            let proposalSummary = messagePayload;

            isDelete = persistentConnectionMessage.type === 'Delete';

            activeTransactions[correlationId].updatedProposalSummary = proposalSummary;
            activeTransactions[correlationId].isProposalDeleted = isDelete;
        }

    function cleanStickyAndReload() {
            var now = new Date();
            document.cookie = 'AWSALB=;path=/;expires='+now.toGMTString();
            document.cookie = 'AWSALBCORS=;path=/;expires='+now.toGMTString();
            $window.location.reload();
    }

        const handleNonSubmissionUpdate = function() {

            const setupMessageType = function() {
                switch (persistentConnectionMessage.type) {
                    case 'alert':
                        var messageObj = convertPersistentConnectionMessageToAlert(persistentConnectionMessage);
                        if (messageObj.message=='action:resetConnections') {
                          cleanStickyAndReload();
                        }
                        else if (messageObj.message=='action:resetConnectionsWithConfirmation') {
                            localization.getTranslations().then(function (translations) {
                              var confirmed = false;
                                let now = moment();
                                modalUtil.showGenericConfirm({
                                  title: _.get(translations, 'serverReconnectModal.title'),
                                  summary:  _.get(translations, 'serverReconnectModal.summary'),
                                  confirmActionButtonLabel: 'OK',
                                  cancelButtonLabel: 'CANCEL'
                                }).then(function () {
                                  cleanStickyAndReload();
                                }).finally(function() {
                                  confirmed = true;
                                });
                                setTimeout(function() {
                                  if (!confirmed) cleanStickyAndReload();
                                }, 60000);
                            });
                        }
                        else {
                          alert(persistentConnectionMessage);
                        }
                        break;
                    case 'Update':
                        isUpdateType = true;
                        break;
                    case 'Create':
                        isCreateType = true;
                        break;
                    case 'Delete':
                        isDeleteType = true;
                        break;
                    case 'Rename':
                        isRenameType = true;
                        break;
                }
            }.bind(this);

            function handleRowMessage() {
                if (activeTransactions[correlationId]) {
                    if (!activeTransactions[correlationId].createRowMessages) {
                        activeTransactions[correlationId].createRowMessages = {};
                    }
                    if (!activeTransactions[correlationId].updateRowMessages) {
                        activeTransactions[correlationId].updateRowMessages = {};
                    }
                    if (!activeTransactions[correlationId].deleteRowMessages) {
                        activeTransactions[correlationId].deleteRowMessages = {};
                    }
                }

                if (isCreateType) {
                    activeTransactions[correlationId].createRowMessages[messagePayload.id] = {
                        messagePayload: messagePayload,
                        createFieldMessages: [],
                        updateFieldMessages: [],
                        deleteFieldMessages: [],
                        renameFieldMessages: []
                    };
                } else if (isDeleteType) {
                    activeTransactions[correlationId].deleteRowMessages[messagePayload.id] = {
                        messagePayload: messagePayload,
                        createFieldMessages: [],
                        updateFieldMessages: [],
                        deleteFieldMessages: [],
                        renameFieldMessages: []
                    };
                } else if (isUpdateType) {
                    activeTransactions[correlationId].updateRowMessages[messagePayload.id] = {
                        messagePayload: messagePayload,
                        formId: messagePayload.formId,
                        createFieldMessages: [],
                        updateFieldMessages: [],
                        deleteFieldMessages: [],
                        renameFieldMessages: []
                    };
                }
            }

            function handleFormMessage() {
                if (isCreateType) {
                    $rootScope.$broadcast(formViewerConstant.event.CREATE_NEW_SUPPLEMENTAL_FORM, messagePayload);
                }
                else if (isDeleteType) {
                    $rootScope.$broadcast(formViewerConstant.event.DELETE_SUPPLEMENTAL_FORM, messagePayload);
                }
                else if (isUpdateType) {
                    let form = messagePayload;
                    if (form.root) {
                        $rootScope.$broadcast(formViewerConstant.event.UPDATE_ROOT_FORM, form);
                    }
                }
            }

            function handleFieldMessage() {
                let createRowMessages = activeTransactions[correlationId].createRowMessages,
                    updateRowMessages,
                    deleteRowMessages = activeTransactions[correlationId].deleteRowMessages;

                if (messagePayload.rowId) {
                    if (!activeTransactions[correlationId].updateRowMessages) {
                        activeTransactions[correlationId].updateRowMessages = {};
                    }
                    updateRowMessages = activeTransactions[correlationId].updateRowMessages;

                    if (!updateRowMessages[messagePayload.rowId]) {
                        updateRowMessages[messagePayload.rowId] = {
                            formId: messagePayload.formId,
                            createFieldMessages: [],
                            updateFieldMessages: [],
                            deleteFieldMessages: [],
                            renameFieldMessages: []
                        };
                    }

                    if (isCreateType) {
                        if (createRowMessages && createRowMessages[messagePayload.rowId]) {
                            createRowMessages[messagePayload.rowId].createFieldMessages.push(messagePayload);
                        } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
                            updateRowMessages[messagePayload.rowId].createFieldMessages.push(messagePayload);
                        } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
                            deleteRowMessages[messagePayload.rowId].createFieldMessages.push(messagePayload);
                        }
                    } else if (isUpdateType) {
                        if (createRowMessages && createRowMessages[messagePayload.rowId]) {
                            createRowMessages[messagePayload.rowId].updateFieldMessages.push(messagePayload);
                        } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
                            updateRowMessages[messagePayload.rowId].updateFieldMessages.push(messagePayload);
                        } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
                            deleteRowMessages[messagePayload.rowId].updateFieldMessages.push(messagePayload);
                        }
                    } else if (isDeleteType) {
                        if (createRowMessages && createRowMessages[messagePayload.rowId]) {
                            createRowMessages[messagePayload.rowId].deleteFieldMessages.push(messagePayload);
                        } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
                            updateRowMessages[messagePayload.rowId].deleteFieldMessages.push(messagePayload);
                        } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
                            deleteRowMessages[messagePayload.rowId].deleteFieldMessages.push(messagePayload);
                        }
                    } else if (isRenameType) {
                        if (createRowMessages && createRowMessages[messagePayload.rowId]) {
                            createRowMessages[messagePayload.rowId].renameFieldMessages.push(messagePayload);
                        } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
                            updateRowMessages[messagePayload.rowId].renameFieldMessages.push(messagePayload);
                        } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
                            deleteRowMessages[messagePayload.rowId].renameFieldMessages.push(messagePayload);
                        }
                    }
                } else {
                    if (isCreateType) {
                        $rootScope.$broadcast(formViewerConstant.event.CREATE_FIELD_MESSAGE, messagePayload);
                    } else if (isUpdateType) {
                        $rootScope.$broadcast(formViewerConstant.event.UPDATE_FIELD_MESSAGE, messagePayload);
                    } else if (isDeleteType) {
                        $rootScope.$broadcast(formViewerConstant.event.DELETE_FIELD_MESSAGE, messagePayload);
                    }
                }
            }

            function handleNavigationItemMessage() {
                if (isUpdateType) {
                    activeTransactions[correlationId].navigationItem = messagePayload.entity;
                    activeTransactions[correlationId].navigationItemSubmissionUri = messagePayload.contextUri;
                    activeTransactions[correlationId].navigationItemActorPrincipalName = actorPrincipalName;
                }
            }

            function handleCollaborationItemMessage() {
                if (isCreateType) {
                    $rootScope.$broadcast(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, messagePayload);
                } else if (isUpdateType) {
                    $rootScope.$broadcast(submissionConstant.event.UPDATE_COLLABORATION_ITEM_MESSAGE, messagePayload);
                } else if (isDeleteType) {
                    $rootScope.$broadcast(submissionConstant.event.DELETE_COLLABORATION_ITEM_MESSAGE, messagePayload);
                }
            }

            function handleActionsMessage() {
                let uriSplits = _.split(objectUri, '/'),
                    entityType = _.toLower(uriSplits[0]),
                    entityId = parseInt(uriSplits[1]);

                if (isUpdateType) {
                    _.each(messagePayload.actions.actions, function (action) {
                        action.name = _.replace(action.name, 'Create Report: ', '');
                    });

                    $rootScope.$broadcast(coreConstant.event.UPDATE_ACTIONS_MESSAGE, messagePayload, entityType, entityId);
                }
            }

            function handleNotificationUpdate() {
                let notification = messagePayload;
                if (isCreateType) {
                    activeTransactions[correlationId].createdNotification = notification;
                } else {
                    if (_.isNil(activeTransactions[correlationId].updatedNotifications)) {
                        activeTransactions[correlationId].updatedNotifications = [];
                    }
                    activeTransactions[correlationId].updatedNotifications.push(notification);
                }
            }

            function handleChatMessageUpdate() {
                if (isCreateType) {
                    $rootScope.$broadcast(submissionConstant.event.CREATE_CHAT_MESSAGE, messagePayload);
                } else if (isUpdateType) {
                    $rootScope.$broadcast(submissionConstant.event.UPDATE_CHAT_MESSAGE, messagePayload);
                } else if (isDeleteType) {
                    $rootScope.$broadcast(submissionConstant.event.DELETE_CHAT_MESSAGE, messagePayload);
                }
            }

            function handleUserUpdate() {
                if (isCreateType) {
                    $rootScope.$broadcast(coreConstant.event.CREATE_USER, messagePayload);
                } else if (isUpdateType) {
                    $rootScope.$broadcast(coreConstant.event.UPDATE_USER, messagePayload);
                } else if (isDeleteType) {
                    $rootScope.$broadcast(coreConstant.event.DELETE_USER, messagePayload);
                }
            }

            function handleOrganizationUpdate() {
                if (isCreateType) {
                    $rootScope.$broadcast(coreConstant.event.CREATE_ORGANIZATION, messagePayload);
                } else if (isUpdateType) {
                    $rootScope.$broadcast(coreConstant.event.UPDATE_ORGANIZATION, messagePayload);
                } else if (isDeleteType) {
                    $rootScope.$broadcast(coreConstant.event.DELETE_ORGANIZATION, messagePayload);
                }
            }

            setupMessageType();

            if (isDynamicDatasetMessage && isUpdateType) {
                let dataItems = messagePayload.items;
                if (!_.isNil(messagePayload.defaultValue)) {
                    _.each(dataItems, function (dataItem) {
                        if (dataItem.value === messagePayload.defaultValue.value) {
                            dataItem.isDefault = true;
                        }
                    });
                }
                messagePayload.items = dataItems;
                $rootScope.$broadcast(coreConstant.event.UPDATE_DATA_SET, messagePayload);
            }

            if (isRowMessage) {
                handleRowMessage();
            } else if (isFormMessage) {
                handleFormMessage();
            } else if (isFieldMessage) {
                handleFieldMessage();
            } else if (isNavigationItemMessage) {
                handleNavigationItemMessage();
            } else if (isCollaborationItemMessage) {
                handleCollaborationItemMessage();
            } else if (isActionsMessage) {
                handleActionsMessage();
            } else if (isNotificationUpdate) {
                handleNotificationUpdate();
            } else if (isChatMessage) {
                handleChatMessageUpdate();
            } else if (isUserMessage) {
                handleUserUpdate();
            } else if (isOrganizationMessage) {
                handleOrganizationUpdate();
            }
        }.bind(this);

        // First, see if we have already processed at least one message from this transaction.
        checkForActiveTransaction(correlationId, totalMessageCount);

        messagesRemaining = activeTransactions[correlationId].messagesRemaining;

        if (isSubmissionUpdate) {
            handleSubmissionUpdate();
        }
        else if (isQuoteUpdate) {
            handleQuoteUpdate();
        }
        else if (isProposalUpdate) {
            handleProposalUpdate();
        }
        else if (isPolicyChangeUpdate) {
            handlePolicyChangeUpdate();
        }
        else if (isPingMessage) {
            umsLog.debug('Received ping.');
        }
        else {
            handleNonSubmissionUpdate();
        }

        // Count down the remaining message count.
        activeTransactions[correlationId].messagesRemaining = --messagesRemaining;

        // If we have received all of the messages we're expecting, we've reached the end of this transaction.
        checkAndHandleEndOfTransaction(messagesRemaining, correlationId);
    }.bind(this);
};

angular.module('umCore')
    .service('persistentConnection', PersistentConnection);
